export default class SlickVehicleGallery {
    public static init() {
		const autoPlay = ($('.phyron-thumbnail').length > 0 ? false: true);
		// if ($('.slick--vehicle-gallery-main').length > 0) {
			$('.slick--vehicle-gallery-main').slick({
				initialSlide: 0,
				slidesToShow: 1,
				lazyLoad: "ondemand",
				slidesToScroll: 1,
				arrows: true,
				prevArrow: "<span class='slick-prev main'>&lt;</span>",
				nextArrow: "<span class='slick-next main'>&gt;</span>",
				fade: true,
				autoplay: autoPlay,
				autoplaySpeed: 3000,
				pauseOnHover: true,
				pauseOnFocus: true,
				swipeToSlide: true,
				responsive: [
					{
						breakpoint: 480,
						settings: {
							autoplay: false
						}
					}
				]
			});
			$('.slick--vehicle-gallery-full-width').slick({
				slidesToScroll: 1,
				arrows: true,
				prevArrow: "<span class='slick-prev main'>&lt;</span>",
				nextArrow: "<span class='slick-next main'>&gt;</span>",
				autoplay: autoPlay,
				centerMode: true,
				variableWidth: true,
				focusOnSelect: true,
				swipeToSlide: true,
				responsive: [
					{
						breakpoint: 755,
						settings: {
							centerMode: false,
							variableWidth: false,
							autoplay: false
						}
					}
				],
			});
			$('.slick--vehicle-gallery-main, .slick--vehicle-gallery-full-width').each(function () {
				(<any>$(this)).magnificPopup({
					delegate: 'a',
					type: 'image',
					gallery: {
						enabled: true
					}
				});
			});

			// Open the gallery from a button click
			$('#open-gallery').on('click', function (e) {
				console.log('clicked');
				e.preventDefault();

				// Trigger click on the first image link in the gallery
				const $gallery = $('.slick--vehicle-gallery-main, .slick--vehicle-gallery-full-width').first();
				const $firstImageLink = $gallery.find('a').first();

				if ($firstImageLink.length) {
					$firstImageLink.trigger('click');
				}
			});
			$( '.slick--vehicle-gallery-main' ).on( 'lazyLoaded', function( evt, slick, $img ) {
				$img
					// Find the parent <picture> tag of img
					.closest('picture')
					// Find <source> tags with data-lazy-srcset attribute
					.find('source[data-lazy-srcset]')
					// Copy data-lazy-srcset to srcset
					.each(function (i: any, $source: any) {
						$source = $($source);
						$source.attr('srcset', $source.data('lazy-srcset'));
					}); 
			} );
		// }
	}
}